export default {
    inject: {
        FormInstance: {
            default: ''
        }
    },
    computed: {
        itemDisabled () {
            let state = this.disabled;
            if (!state && this.FormInstance) state = this.FormInstance.disabled;
            return state;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/view-design/src/mixins/form.js
// module id = aOkN
// module chunks = 100